export const potentialUsers = [
  '1-5 users',
  '6-20 users',
  '21-100 users',
  '101-500 users',
  '501-3,500 users',
  '3,500+ users'
]

export const purchasingTimeFrame = [
  'Immediately',
  '1-3 months',
  '3-6 months',
  '12+ months'
]

export const potentialSalesValue = [
  'less than $5,000',
  '$5,001 - $25,000',
  '$25,001 - $50,000',
  '$50,001 - $100,000',
  '$100,000+'
]

export const salesforceRegion = [
  'Canada, West',
  'Canada, East',
  'USA, West',
  'USA, East',
  'UK & Ireland',
  'Other'
]

export const serviceInterest = [
  'Marketing Cloud',
  'Pardot',
  'Sales & Service Cloud',
  'Community Cloud',
  'Interacton Studio',
  'Datorama',
  'Tableau',
  'Customer 360/CDP'

]

export const salesforceSegment = [
 'Small Business',
 'Growth Business',
 'Mid-Market',
 'General Business',
 'Strategic or Enterprise'
]

export default potentialUsers



// WEBPACK FOOTER //
// ./src/Picklists.js